// src/Providers.js
import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { TabGuardProvider } from './contexts/TabGuardContext';
import DialogProvider from './contexts/DialogContext';
import { SignalRProvider } from "./contexts/SignalRContext";
import { SnackbarProvider } from './contexts/SnackbarContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { WithdrawalProvider } from './contexts/WithdrawalContext';
import { BankAccountProvider } from './contexts/BankAccountContext';

const theme = createTheme({
  palette: {
    primary: { main: '#e4b457' },
    secondary: { main: '#818181' },
  },
});

const Providers = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
          <DialogProvider>
            <AuthProvider>
              <TabGuardProvider>
                <WithdrawalProvider>
                  <SignalRProvider>
                    <BankAccountProvider>
                      {children}
                    </BankAccountProvider>
                  </SignalRProvider>
                </WithdrawalProvider>
              </TabGuardProvider>
            </AuthProvider>
          </DialogProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default Providers;
